import * as React from 'react'
import * as R from 'ramda'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import IconButton from 'material-ui/IconButton'
import AppBar from 'material-ui/AppBar'
import Card from 'material-ui/Card/Card'
import {indexedMap} from '../../Data/ArrayHelper'
import {ProductCalculationImportState} from './ProductCalculationImportState'
import {ProductCalculationImportAction} from './ProductCalculationImportActions'
import RaisedButton from 'material-ui/RaisedButton'
import {ProductCalclationImportFormularView} from './ProductCalculationImportFormularView'
import {ProductCalculationImportCreateMessageModal} from './ProductCalculationImportCreateMessageModal'
import {ChangeEvent} from 'react'
import {errorMessage} from '../../Data/FormValidation'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import FilteredMultiSelect from 'react-filtered-multiselect'
import {Customer} from '../../Entities/Customer'
import injectSheet from 'react-jss'

interface Properties {
    readonly state: ProductCalculationImportState,
    readonly dispatch: (action: ProductCalculationImportAction) => void,
}

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    productCalculationImportWrapper: {
        overflowY: 'scroll',
        flex: '1'
    },
    row: {
        padding: '32px',
        boxSizing: 'border-box'
    },
    rowWithFlex: {
        padding: '32px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column'
    },
    button: {
        marginLeft: 'auto'
    }
}

export const ProductCalculationImportView =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}) => {
            const availableCustomers =
                R.filter(
                    (customerToFilter: Customer) => {
                        return R.reduce(
                            (acc: boolean, elem: Customer) => {
                                if (elem.id === customerToFilter.id) {
                                    return false
                                }
                                return acc
                            },
                            true,
                            state.form.selectedCustomers
                        )
                    },
                    state.availableCustomers
                )
            return (
                <div className={classes.root}>
                    <div className="navigation">
                        <AppBar
                            title="Produktkalkulation erstellen"
                            className="navigation__bar"
                            iconElementLeft={
                                <IconButton
                                    onTouchTap={() =>
                                        dispatch({
                                            type: 'MenuButtonClicked',
                                        })}
                                >
                                    <NavigationMenu/>
                                </IconButton>}
                        />
                    </div>
                    {!state.showFormular &&
                    <div className={classes.productCalculationImportWrapper}>
                        <div className={`row ${classes.row}`}>
                            <div className="column">
                                <Card>
                                    <div className="card__header">
                                        <h4 style={{marginBottom: 0}}>Neue
                                            Produktkalkulation hinzufügen</h4>
                                    </div>
                                    <div className="card__content">
                                        <div
                                            style={{
                                                width: 'calc(50% - 16px)',
                                                marginRight: '16px',
                                                float: 'left'
                                            }}
                                        >
                                            Verfügbare Customer:<br/>
                                            <FilteredMultiSelect
                                                className={'multiselect-container'}
                                                classNames={
                                                    {
                                                        button: 'multiselect-button',
                                                        // Used when at least one <option> is selected
                                                        buttonActive: 'multiselect-button-active',
                                                        filter: 'multiselect-filter',
                                                        select: 'multiselect-select'
                                                    }
                                                }
                                                onChange={(selections: Customer[]) => {
                                                    dispatch({
                                                        type: 'AddToSelectedCustomers',
                                                        values: selections
                                                    })
                                                }}
                                                options={availableCustomers}
                                                valueProp="id"
                                                textProp="longName"
                                                buttonText={'HINZUFÜGEN'}
                                                placeholder={'Suchen...'}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                width: 'calc(50% - 16px)',
                                                marginLeft: '16px',
                                                float: 'left'
                                            }}
                                        >
                                            Zugewiesene Kunden:<br/>
                                            <FilteredMultiSelect
                                                className={'multiselect-container'}
                                                classNames={
                                                    {
                                                        button: 'multiselect-button',
                                                        // Used when at least one <option> is selected
                                                        buttonActive: 'multiselect-button-active',
                                                        filter: 'multiselect-filter',
                                                        select: 'multiselect-select'
                                                    }
                                                }
                                                onChange={(selections: Customer[]) => {
                                                    dispatch({
                                                        type: 'RemoveFromSelectedCustomers',
                                                        values: selections
                                                    })
                                                }}
                                                options={state.form.selectedCustomers}
                                                valueProp="id"
                                                textProp="longName"
                                                buttonText={'Entfernen'}
                                                placeholder={'Suchen...'}
                                            />
                                        </div>
                                        {state.attemptedShowFormular && state.form.selectedCustomers.length <= 0 &&
                                        <div
                                            style={{
                                                width: '100%',
                                                textAlign: 'center',
                                                color: 'rgb(244, 67, 54)',
                                                fontStyle: 'italic'
                                            }}
                                        >
                                            Es muss mindestens ein Kunde ausgewählt werden!
                                        </div>
                                        }
                                        <SelectField
                                            floatingLabelText="Produkt Versand Dienstleister"
                                            value={state.form.selectedShippingServiceId}
                                            onChange={(event, index, value) => {
                                                dispatch({
                                                    type: 'ChangeSelectedShippingService',
                                                    value: value
                                                })
                                            }}
                                            underlineDisabledStyle={{display: 'none'}}
                                            fullWidth={true}
                                            errorText={errorMessage(state.form.selectedShippingServiceValidation)}
                                        >
                                            {indexedMap(
                                                (index, shippingService) =>
                                                    <MenuItem
                                                        key={shippingService.id}
                                                        value={shippingService.id}
                                                        primaryText={shippingService.longName}
                                                    />,
                                                state.availableShippingServices,
                                            )}
                                        </SelectField>
                                    </div>
                                    <div className="card__content">
                                        Importieren sie ihre Produktkalkulation aus
                                        einer CSV-Datei
                                        oder tragen sie Attribute und Preise händisch
                                        ein!
                                        {state.csvUploadStatus.type === 'Error' &&
                                        <div
                                            style={{
                                                margin: '0 24px',
                                                color: 'Red',
                                                display: 'inline-block'
                                            }}
                                        >
                                            {state.csvUploadStatus.reason}
                                        </div>
                                        }
                                    </div>
                                    <div className="card__content">
                                        <RaisedButton
                                            label="CSV-Datei auswählen"
                                            primary={true}
                                            onClick={() => {
                                                const input =
                                                    document.getElementById('csv-prod-calc-upload-input')
                                                if (input !== null) {
                                                    input.dispatchEvent(new MouseEvent('click'))
                                                }
                                            }}
                                        />
                                        <input
                                            type="file"
                                            onChange={
                                                (event: ChangeEvent<HTMLInputElement>) => {
                                                    const {files} = event.target
                                                    if (files === null || files.length < 1) {
                                                        return
                                                    }
                                                    const fileReader = new FileReader()
                                                    fileReader.readAsText(files[0])
                                                    fileReader.addEventListener('loadend', () => {
                                                        dispatch({
                                                            type: 'CSVProductCalculationUpload',
                                                            content: fileReader.result
                                                        })
                                                    })
                                                    event.target.value = ''
                                                }}
                                            id="csv-prod-calc-upload-input"
                                            style={{display: 'none'}}
                                        />
                                        <RaisedButton
                                            style={{marginLeft: '32px'}}
                                            label="Manuell erstellen"
                                            primary={true}
                                            onTouchTap={() => dispatch({
                                                type: 'ManuelCreation'
                                            })}
                                        />
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                    }
                    {state.showFormular &&
                    <div className={classes.productCalculationImportWrapper}>
                        <div className={classes.rowWithFlex}>
                            <ProductCalculationImportCreateMessageModal
                                state={state}
                                dispatch={dispatch}
                            />
                            <ProductCalclationImportFormularView
                                form={state.form}
                                dispatch={dispatch}
                            />
                            <RaisedButton
                                className={classes.button}
                                disabled={state.attemptingToSave}
                                label="Produktkalkulation speichern"
                                primary={true}
                                onTouchTap={() => dispatch({
                                    type: 'SubmitProductCalculationImportFormular'
                                })}
                            />
                        </div>
                    </div>
                    }
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationImport/ProductCalculationImportView.tsx